/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AssignLearningToLearningDTO,
    AssignLearningToLearningDTOFromJSON,
    AssignLearningToLearningDTOToJSON,
    DuplicateDisciplineReportRowDTO,
    DuplicateDisciplineReportRowDTOFromJSON,
    DuplicateDisciplineReportRowDTOToJSON,
    FilterOptionsDTO,
    FilterOptionsDTOFromJSON,
    FilterOptionsDTOToJSON,
    LearningCompetenceDTOPagedResponse,
    LearningCompetenceDTOPagedResponseFromJSON,
    LearningCompetenceDTOPagedResponseToJSON,
    LearningCompetencesQueryParams,
    LearningCompetencesQueryParamsFromJSON,
    LearningCompetencesQueryParamsToJSON,
    LearningOutcomesReportProgramDTO,
    LearningOutcomesReportProgramDTOFromJSON,
    LearningOutcomesReportProgramDTOToJSON,
    MissingTitularReportRowDTO,
    MissingTitularReportRowDTOFromJSON,
    MissingTitularReportRowDTOToJSON,
    NonApprovedSubjectReportRowDTO,
    NonApprovedSubjectReportRowDTOFromJSON,
    NonApprovedSubjectReportRowDTOToJSON,
    StudyCycleEnum,
    StudyCycleEnumFromJSON,
    StudyCycleEnumToJSON,
    StudyProgramDTO,
    StudyProgramDTOFromJSON,
    StudyProgramDTOToJSON,
    StudyProgramDTOPagedResponse,
    StudyProgramDTOPagedResponseFromJSON,
    StudyProgramDTOPagedResponseToJSON,
    StudyProgramQueryParams,
    StudyProgramQueryParamsFromJSON,
    StudyProgramQueryParamsToJSON,
    StudyProgramUpdateDTO,
    StudyProgramUpdateDTOFromJSON,
    StudyProgramUpdateDTOToJSON,
} from '../models';

export interface ApiStudyProgramAddStudyprogramPostRequest {
    studyProgramUpdateDTO?: StudyProgramUpdateDTO;
}

export interface ApiStudyProgramAssignLearningsToLearningPostRequest {
    assignLearningToLearningDTO?: AssignLearningToLearningDTO;
}

export interface ApiStudyProgramDeleteIdDeleteRequest {
    id: string;
}

export interface ApiStudyProgramDeleteLearningIdDeleteRequest {
    id: string;
    force?: boolean;
}

export interface ApiStudyProgramGetAllLearningCompetencesPostRequest {
    learningCompetencesQueryParams?: LearningCompetencesQueryParams;
}

export interface ApiStudyProgramGetAllStudyProgramsPostRequest {
    studyProgramQueryParams?: StudyProgramQueryParams;
}

export interface ApiStudyProgramGetDuplicateDisciplinesReportPostRequest {
    studyProgramQueryParams?: StudyProgramQueryParams;
}

export interface ApiStudyProgramGetFilterOptionsGetRequest {
    studyCycle?: StudyCycleEnum;
}

export interface ApiStudyProgramGetLearningOutcomesReportPostRequest {
    studyProgramQueryParams?: StudyProgramQueryParams;
}

export interface ApiStudyProgramGetMissingTitularsReportPostRequest {
    studyProgramQueryParams?: StudyProgramQueryParams;
}

export interface ApiStudyProgramGetNonApprovedSubjectsReportPostRequest {
    studyProgramQueryParams?: StudyProgramQueryParams;
}

export interface ApiStudyProgramGetStudyProgramByIdIdGetRequest {
    id: string;
}

export interface ApiStudyProgramUpdateStudyProgramIdPutRequest {
    id: string;
    studyProgramUpdateDTO?: StudyProgramUpdateDTO;
}

/**
 * 
 */
export class StudyProgramApi extends runtime.BaseAPI {

    /**
     */
    async apiStudyProgramAddStudyprogramPostRaw(requestParameters: ApiStudyProgramAddStudyprogramPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/AddStudyprogram`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramUpdateDTOToJSON(requestParameters.studyProgramUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyProgramAddStudyprogramPost(requestParameters: ApiStudyProgramAddStudyprogramPostRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyProgramAddStudyprogramPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyProgramAssignLearningsToLearningPostRaw(requestParameters: ApiStudyProgramAssignLearningsToLearningPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/AssignLearningsToLearning`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignLearningToLearningDTOToJSON(requestParameters.assignLearningToLearningDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyProgramAssignLearningsToLearningPost(requestParameters: ApiStudyProgramAssignLearningsToLearningPostRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyProgramAssignLearningsToLearningPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyProgramDeleteIdDeleteRaw(requestParameters: ApiStudyProgramDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyProgramDeleteIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyProgramDeleteIdDelete(requestParameters: ApiStudyProgramDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyProgramDeleteIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyProgramDeleteLearningIdDeleteRaw(requestParameters: ApiStudyProgramDeleteLearningIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyProgramDeleteLearningIdDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/DeleteLearning/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyProgramDeleteLearningIdDelete(requestParameters: ApiStudyProgramDeleteLearningIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyProgramDeleteLearningIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiStudyProgramGetAllLearningCompetencesPostRaw(requestParameters: ApiStudyProgramGetAllLearningCompetencesPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<LearningCompetenceDTOPagedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetAllLearningCompetences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LearningCompetencesQueryParamsToJSON(requestParameters.learningCompetencesQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LearningCompetenceDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyProgramGetAllLearningCompetencesPost(requestParameters: ApiStudyProgramGetAllLearningCompetencesPostRequest = {}, initOverrides?: RequestInit): Promise<LearningCompetenceDTOPagedResponse> {
        const response = await this.apiStudyProgramGetAllLearningCompetencesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetAllStudyProgramsPostRaw(requestParameters: ApiStudyProgramGetAllStudyProgramsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StudyProgramDTOPagedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetAllStudyPrograms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramQueryParamsToJSON(requestParameters.studyProgramQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyProgramDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyProgramGetAllStudyProgramsPost(requestParameters: ApiStudyProgramGetAllStudyProgramsPostRequest = {}, initOverrides?: RequestInit): Promise<StudyProgramDTOPagedResponse> {
        const response = await this.apiStudyProgramGetAllStudyProgramsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetDuplicateDisciplinesReportPostRaw(requestParameters: ApiStudyProgramGetDuplicateDisciplinesReportPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<DuplicateDisciplineReportRowDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetDuplicateDisciplinesReport`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramQueryParamsToJSON(requestParameters.studyProgramQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DuplicateDisciplineReportRowDTOFromJSON));
    }

    /**
     */
    async apiStudyProgramGetDuplicateDisciplinesReportPost(requestParameters: ApiStudyProgramGetDuplicateDisciplinesReportPostRequest = {}, initOverrides?: RequestInit): Promise<Array<DuplicateDisciplineReportRowDTO>> {
        const response = await this.apiStudyProgramGetDuplicateDisciplinesReportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetFilterOptionsGetRaw(requestParameters: ApiStudyProgramGetFilterOptionsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<FilterOptionsDTO>> {
        const queryParameters: any = {};

        if (requestParameters.studyCycle !== undefined) {
            queryParameters['studyCycle'] = requestParameters.studyCycle;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetFilterOptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FilterOptionsDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyProgramGetFilterOptionsGet(requestParameters: ApiStudyProgramGetFilterOptionsGetRequest = {}, initOverrides?: RequestInit): Promise<FilterOptionsDTO> {
        const response = await this.apiStudyProgramGetFilterOptionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetLearningOutcomesReportPostRaw(requestParameters: ApiStudyProgramGetLearningOutcomesReportPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<LearningOutcomesReportProgramDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetLearningOutcomesReport`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramQueryParamsToJSON(requestParameters.studyProgramQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LearningOutcomesReportProgramDTOFromJSON));
    }

    /**
     */
    async apiStudyProgramGetLearningOutcomesReportPost(requestParameters: ApiStudyProgramGetLearningOutcomesReportPostRequest = {}, initOverrides?: RequestInit): Promise<Array<LearningOutcomesReportProgramDTO>> {
        const response = await this.apiStudyProgramGetLearningOutcomesReportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetMissingTitularsReportPostRaw(requestParameters: ApiStudyProgramGetMissingTitularsReportPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<MissingTitularReportRowDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetMissingTitularsReport`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramQueryParamsToJSON(requestParameters.studyProgramQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MissingTitularReportRowDTOFromJSON));
    }

    /**
     */
    async apiStudyProgramGetMissingTitularsReportPost(requestParameters: ApiStudyProgramGetMissingTitularsReportPostRequest = {}, initOverrides?: RequestInit): Promise<Array<MissingTitularReportRowDTO>> {
        const response = await this.apiStudyProgramGetMissingTitularsReportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetNonApprovedSubjectsReportPostRaw(requestParameters: ApiStudyProgramGetNonApprovedSubjectsReportPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<NonApprovedSubjectReportRowDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetNonApprovedSubjectsReport`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramQueryParamsToJSON(requestParameters.studyProgramQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NonApprovedSubjectReportRowDTOFromJSON));
    }

    /**
     */
    async apiStudyProgramGetNonApprovedSubjectsReportPost(requestParameters: ApiStudyProgramGetNonApprovedSubjectsReportPostRequest = {}, initOverrides?: RequestInit): Promise<Array<NonApprovedSubjectReportRowDTO>> {
        const response = await this.apiStudyProgramGetNonApprovedSubjectsReportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramGetStudyProgramByIdIdGetRaw(requestParameters: ApiStudyProgramGetStudyProgramByIdIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StudyProgramDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyProgramGetStudyProgramByIdIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/GetStudyProgramById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudyProgramDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiStudyProgramGetStudyProgramByIdIdGet(requestParameters: ApiStudyProgramGetStudyProgramByIdIdGetRequest, initOverrides?: RequestInit): Promise<StudyProgramDTO> {
        const response = await this.apiStudyProgramGetStudyProgramByIdIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiStudyProgramUpdateStudyProgramIdPutRaw(requestParameters: ApiStudyProgramUpdateStudyProgramIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiStudyProgramUpdateStudyProgramIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/StudyProgram/UpdateStudyProgram/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StudyProgramUpdateDTOToJSON(requestParameters.studyProgramUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiStudyProgramUpdateStudyProgramIdPut(requestParameters: ApiStudyProgramUpdateStudyProgramIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiStudyProgramUpdateStudyProgramIdPutRaw(requestParameters, initOverrides);
    }

}
